module.exports = __webpack_public_path__ + "img/finantari-eligibile-background.4d9d0230.png";